module.exports = __webpack_public_path__ + "static/media/argument2_pic1.cbd34cc1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/argument2_pic1.jpg
 ** module id = 431
 ** module chunks = 0
 **/